export default __webpack_public_path__ + "static/media/Landing.c8b0ad7a.jpg";